angular.module('unica_campaign_attachment.campaign_attachment_services')

.factory('CampaignAttachmentDeleteService', function ($http, getBaseApiURL) {

	var campaignAttachmentDeleteService = {};

	campaignAttachmentDeleteService.delete = function (campaignAttachmentId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/campaign-attachment/delete/' + campaignAttachmentId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return campaignAttachmentDeleteService;
});